import { type ReactNode } from "react";
import {
  useForm,
  type SubmitHandler,
  type UseFormReturn,
} from "react-hook-form";

type FormProps<T extends Record<string, any>> = {
  action: string;
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  onBefore?: () => void,
  // eslint-disable-next-line no-unused-vars
  children: (form: UseFormReturn<T>) => ReactNode;
  // eslint-disable-next-line no-unused-vars
  onSuccess?: (data: unknown) => void;
  // eslint-disable-next-line no-unused-vars
  onError?: (error: unknown) => void;
};

const Form = <T extends Record<string, any>>({
  action,
  method = "POST",
  onBefore,
  children,
  onSuccess,
  onError,
}: FormProps<T>) => {

  const form = useForm<T>();

  const handleSubmit: SubmitHandler<T> = async (values) => {
    onBefore()
    try {
      const res = await fetch(action, {
        method,
        headers:
          method === "GET" ? undefined : { "Content-Type": "application/json" },
        body: method === "GET" ? undefined : JSON.stringify(values),
      });

      if (!res.ok) throw new Error(`Request failed: ${res.status}`);

      const contentType = res.headers.get("content-type");
      const data = contentType?.includes("application/json")
        ? await res.json()
        : await res.text();

      onSuccess?.(data);
    } catch (err) {
      onError?.(err);
    }
  };

  return (
    <form onSubmit={form.handleSubmit(handleSubmit)}>
      <div className="fields-container">{children(form)}</div>
    </form>
  );
};

export default Form;
